<template>
  <b-form>
    <b-form-group
      label="Fecha y Hora"
      label-for="name"
    >
      <flat-pickr
        v-model="fechaSel"
        class="form-control"
        :config="configDP"
      />
    </b-form-group>
    <b-form-group
      label="Seleccione Departamento"
      label-for="dpto"
    >
      <v-select
        v-model="dptoSel"
        :reduce="m => m.idUbigeo"
        label="descripcion"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="dptos"
        @input="getUbigeos('prov', dptoSel.slice(0, 2))"
      />
    </b-form-group>
    <b-form-group
      label="Seleccione Provincia"
      label-for="prov"
    >
      <v-select
        v-model="provSel"
        :reduce="m => m.idUbigeo"
        label="descripcion"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="provs"
        @input="getUbigeos('dist', provSel.slice(0, 4))"
      />
    </b-form-group>
    <b-form-group
      label="Seleccione Distrito"
      label-for="dist"
    >
      <v-select
        v-model="distSel"
        :reduce="m => m.idUbigeo"
        label="descripcion"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="dists"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import {
  BForm, BFormGroup,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import moment from 'moment-timezone'
import store from '@/store'

export default {
  components: {
    BForm,
    BFormGroup,
    flatPickr,
    vSelect,
  },
  emits: ['update:is-busy-ficha', 'update:modal-show'],
  props: {
    typeAction: {
      type: String,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      formData: {},
      fechaSel: null,
      dptoSel: null,
      provSel: null,
      distSel: null,
      dptos: [],
      provs: [],
      dists: [],
      configDP: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S ',
        altInput: true,
        altFormat: 'd/m/Y H:i:S',
      },
    }
  },
  async mounted() {
    if (this.typeAction === 'new') {
      this.fechaSel = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss')
      this.dptoSel = '220000'
      await this.getUbigeos('dpto', '')
      await this.getUbigeos('prov', this.dptoSel.slice(0, 2))
    }
    if (this.typeAction === 'edit') {
      this.fechaSel = moment(this.dataEdit.fecha).format('YYYY-MM-DD[T]HH:mm:ss')
      this.dptoSel = `${this.dataEdit.ubigeo.idUbigeo.slice(0, 2)}0000`
      await this.getUbigeos('dpto', '')
      await this.getUbigeos('prov', this.dataEdit.ubigeo.idUbigeo.slice(0, 2))
      this.provSel = `${this.dataEdit.ubigeo.idUbigeo.slice(0, 4)}00`
      await this.getUbigeos('dist', this.dataEdit.ubigeo.idUbigeo.slice(0, 4))
      this.distSel = this.dataEdit.ubigeo.idUbigeo
    }
  },
  methods: {
    async getUbigeos(type, codUbigeo) {
      await store
        .dispatch('catalogos/UBIGEO_FIND_ALL', {
          get: type,
          codUbigeo,
        })
        .then(response => {
          if (type === 'dpto') {
            this.dptos = response
            this.provSel = null
            this.distSel = null
            this.provs = []
            this.dists = []
          }
          if (type === 'prov') {
            this.provs = response
            this.provSel = null
            this.distSel = null
            this.dists = []
          }
          if (type === 'dist') {
            this.dists = response
          }
        })
        .catch(error => {
          this.showError(error)
        })
    },
    async saveForm() {
      // Validar datos antes
      let service = 'reclutamiento/FICHA_CREATE'
      if (this.typeAction === 'edit') {
        this.formData.idFichaReclutamiento = this.dataEdit.idFichaReclutamiento
        service = 'reclutamiento/FICHA_UPDATE'
      }
      this.formData.etapa = 1
      this.formData.fecha = moment.tz(moment(String(this.fechaSel)).format('YYYY-MM-DD[T]HH:mm:ss'), 'America/Lima')
      this.formData.ubigeo = {
        idUbigeo: this.distSel,
      }
      this.formData.usuario = {
        idUsuario: 1,
      }

      await store.dispatch(service, this.formData)
        .then(response => {
          this.$emit('refetch-data', response)
          this.$emit('update:modal-show', false)
        })
        .catch(error => {
          this.$emit('error-data', error)
        })
      this.$emit('update:is-busy-ficha', false)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
